module.exports = __webpack_public_path__ + "static/media/31-10.9f2f175a.mp3";